export default {
  UPDATE_DATE_FROM_TO: 'UPDATE_DATE_FROM_TO',
  GET_ORDER_STATS: 'GET_ORDER_STATS',
  GET_WORKSHOP_STATS: 'GET_WORKSHOP_STATS',
  GET_TYPES_WORKSHOP: 'GET_TYPES_WORKSHOP',
  GET_REST_POINTS: 'GET_REST_POINTS',
  GET_DELIVERY_TYPES: 'GET_DELIVERY_TYPES',
  UPDATE_SELECTED_RESTPOINT: 'UPDATE_SELECTED_RESTPOINT',
  UPDATE_SELECTED_DELIVERY_TYPE: 'UPDATE_SELECTED_DELIVERY_TYPE',
  DATE_UPDATED: 'DATE_UPDATED',
  FILTER_UPDATED: 'FILTER_UPDATED',
  REQUEST_STATS: 'REQUEST_STATS',
  GET_WORKERS_STATS: 'GET_WORKERS_STATS',
  GET_WORKERS: 'GET_WORKERS',
  UPDATE_SELECTED_WORKER: 'UPDATE_SELECTED_WORKER',
  WORKER_UPDATED: 'WORKER_UPDATED',
  GROUP_BY_DAY_UPDATED: 'GROUP_BY_DAY_UPDATED',
  GET_CONFIG_ROLLS_COUNT: 'GET_CONFIG_ROLLS_COUNT',
}
export const accountACT = {
  LOGIN: 'LOGIN',
  LOGOUT: 'LOGOUT',
  VALIDATE_RELEVANCE_TOKEN: 'VALIDATE_RELEVANCE_TOKEN',
  DECODE_TOKEN: 'DECODE_TOKEN',
  IDENTIFY_USER_ROLE: 'IDENTIFY_USER_ROLE',
  CHECK_RELEVANCE_TOKEN: 'CHECK_RELEVANCE_TOKEN'
}

export const workerCallCenterStatsACT = {
  UPDATE_STATS: 'UPDATE_STATS'
}

export const orderWorkshopACT = {
  REQUEST_INIT_DATA: 'REQUEST_INIT_DATA',
  GET_WORKSHOP_COOKED_STATS: 'GET_WORKSHOP_COOKED_STATS'
}

export const orderTimeACT = {
  REQUEST_INIT_DATA: 'REQUEST_INIT_DATA',
  GET_ORDER_TIME_STATS: 'GET_ORDER_TIME_STATS'
}

export const callCenterACT = {
  REQUEST_CLIENT: 'REQUEST_CLIENT',
  UPDATE_CLIENT_COMMENT: 'UPDATE_CLIENT_COMMENT',
  CREATE_CLIENT_PROFILE: 'CREATE_CLIENT_PROFILE',
  UPDATE_ORDER_DISCOUNT: 'UPDATE_ORDER_DISCOUNT',
  UPDATE_ORDER_ADDRESS: 'UPDATE_ORDER_ADDRESS',
  CLIENT_UPDATED: 'CLIENT_UPDATED',
  CC_CONFIGS_BATCH_GET: 'CC_CONFIGS_BATCH_GET',
  GET_DISCOUNT_OPTIONS: 'GET_DISCOUNT_OPTIONS',
  SET_ORDER_DISCOUNT: 'SET_ORDER_DISCOUNT',
  RESULT_WARNING_MODAL: 'RESULT_WARNING_MODAL',
  SET_CURRENT_ORDER: 'SET_CURRENT_ORDER',
  REQUEST_PROMOCODES: 'REQUEST_PROMOCODES',
  SET_ORDER_PROMOCODE: 'SET_ORDER_PROMOCODE',
  ADD_PRODUCT_BY_ID_ORIGIN: 'ADD_PRODUCT_BY_ID_ORIGIN',
  ADD_PROMOCODE_GOOD: 'ADD_PROMOCODE_GOOD',
  CHECK_PROMOCODE_GOOD: 'CHECK_PROMOCODE_GOOD',
  GET_CONFIG_ORDERS_COUNT: 'GET_CONFIG_ORDERS_COUNT',
  GET_LAST_ID: 'GET_LAST_ID',
  GET_COURIER_AUTO_ASSIGN_STATUS: 'GET_COURIER_AUTO_ASSIGN_STATUS',
  GET_IS_REST_MANAGER: 'GET_IS_REST_MANAGER'
}

export const motivateAccountingACT = {
  REQUEST_CURRENT_WORKERS_LIST: 'REQUEST_CURRENT_WORKERS_LIST'
}
export const overallWorkshopStatsAct = {
  REQUEST_WORKER_LIST: 'REQUEST_WORKER_LIST',
  REQUEST_STATS_WORKSHOP: 'REQUEST_STATS_WORKSHOP',
  REQUEST_TURNOVER_PERCENTS: 'REQUEST_TURNOVER_PERCENTS',
  REQUEST_TOTAL_TURNOVER: 'REQUEST_TOTAL_TURNOVER',
  CHANGE_CURRENT_DATE: 'CHANGE_CURRENT_DATE'
}

export const workshopsACT = {
  REQUEST_MOTIVATE_INFO: 'REQUEST_MOTIVATE_INFO',
  REQUEST_WORKSHOPS: 'REQUEST_WORKSHOPS'
}

export const motivateMonitorWorkshopACT = {
  requestTargetStats: 'requestTargetStats'
}



// WEBPACK FOOTER //
// ./src/constants/vuexActions.js